
import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, UserPlus } from 'lucide-react';

interface UserListHeaderProps {
  searchTerm: string;
  setSearchTerm: (value: string) => void;
  openAddUserDialog: () => void;
  editing: boolean;
}

const UserListHeader: React.FC<UserListHeaderProps> = ({
  searchTerm,
  setSearchTerm,
  openAddUserDialog,
  editing
}) => {
  return (
    <div className="flex justify-between items-center">
      <div className="relative w-64">
        <Search className="absolute left-2 top-2.5 h-4 w-4 text-muted-foreground pointer-events-none" />
        <Input 
          placeholder="Search users..." 
          className="pl-8" 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      
      <Button 
        disabled={!editing} 
        className="flex items-center gap-1"
        onClick={openAddUserDialog}
      >
        <UserPlus className="h-4 w-4" />
        Add User
      </Button>
    </div>
  );
};

export default UserListHeader;
